export default function ObserverPage() {
  return (
    <ul>
      <li>Observer: </li>
    </ul>
  );
}
